import {
    LOAD_SHIPPING_DASHBOARD,
    LOAD_SHIPPING_DETAIL,
    REMOVE_LISTS,
} from './actions'

const initialState = {
    loading: false,
    data_info: null,
    data_list: [],
    data_count: 0,
    data_all_count: 0,

    // *Start ดึงข้อมูลมาแสดงหน้า Dashboard 
    data_for_shipping_dashboard: [],
    data_count: 0,
    data_all_count: 0,
    // *End ดึงข้อมูลมาแสดงหน้า Dashboard 

    loading_for_data_info: false,
    check_load_data_info: true,
}

export default (state = initialState, action) => {
    switch (action.type) {
        case REMOVE_LISTS:
            return initialState

        case LOAD_SHIPPING_DASHBOARD.REQUEST:
            return {
              ...state,
              loading: action.payload.loading,
            }

        case LOAD_SHIPPING_DASHBOARD.SUCCESS:
            let last_data = state.data_for_isupply_dashboard
            let newer_data = action.payload.lists.data
            let data_all = []
            let data_count = 0
            
            if (action.payload.offset > 0) {

                // ถ้าข้อมูลเดิมมีอยู่แล้ว ให้เช็คก่อนว่าซ้ำกับข้อมูลใหม่มั้ย
                if (last_data.length > 0) {
                    let old_data = last_data[last_data.length - 1]
                    let new_data = newer_data[0]

                    // ?เช็คว่าข้อมูลนี้มี main_title_id ตรงกันหรือไม่
                    if (old_data.main_title_id == new_data.main_title_id) {
                        old_data = {
                            ...old_data,
                            main_go_to: old_data.main_go_to + new_data.main_go_to,
                            main_no_status: old_data.main_no_status + new_data.main_no_status,
                            main_sum_status:
                              old_data.main_sum_status + new_data.main_sum_status,
                            main_work_success:
                              old_data.main_work_success + new_data.main_work_success,
                        }

                        new_data.main_data.forEach((newer) => {
                            let match = 0
                            old_data.main_data.forEach((old) => {
                              // ?จัดกลุ่มโดย บริษัทขนส่ง
                              // TODO: เช็คว่าปลายทางและวัตถุดิบตรงกันหรือไม่
                              // ?จัดกลุ่มโดย ปลายทางหรือต้นทาง
                              // TODO: เช็คว่าชื่อบริษัทและวัตถุดิบตรงหรือไม่
                              if (
                                ((action.payload.group_by == 'vendor' ||
                                  action.payload.group_by == 'material') &&
                                  old.dest_locations_id == newer.dest_locations_id &&
                                  old.material_id == newer.material_id) ||
                                ((action.payload.group_by == 'plant' ||
                                  action.payload.group_by == 'mill') &&
                                  old.vendor_id == newer.vendor_id &&
                                  old.material_id == newer.material_id)
                              ) {
                                old.no_status = old.no_status + newer.no_status
                                old.go_to = old.go_to + newer.go_to
                                old.sum_status = old.sum_status + newer.sum_status
                                old.work_success = old.work_success + newer.work_success
                                old.data_sup_header = old.data_sup_header.concat(
                                  newer.data_sup_header
                                )
                                match = 1
                              }
                            })
              
                            // ?ไม่มีข้อมูลที่ซ้ำกับข้อมูลก่อนหน้า ให้เพิ่มต่อจากข้อมูลก่อนหน้า
                            if (match == 0) {
                              old_data = {
                                ...old_data,
                                main_data: old_data.main_data.concat(newer),
                              }
                            }
                          })
                    }
                }

                //รวมข้อมูลเก่าและใหม่เข้าด้วยกัน
                data_all = last_data.concat(newer_data)
                data_count =
                action.payload.check_load == 1
                    ? state.data_count
                    : state.data_count + action.payload.lists.data_count

            } else {
                data_all = newer_data
                data_count =
                  action.payload.check_load == 1
                    ? state.data_count
                    : action.payload.lists.data_count
            }
            return {
                ...state,
                data_for_shipping_dashboard: data_all,
                data_count: data_count,
                data_all_count: action.payload.lists.data_all_count,
                loading: false,
            }

        case LOAD_SHIPPING_DETAIL.REQUEST:
          return {
            ...state,
            loading_for_data_info: action.payload.data.loading,
            check_load_data_info: true,
          }
        
        case LOAD_SHIPPING_DETAIL.SUCCESS:
          return {
            ...state,
            data_info : action.payload.lists.data,
            loading_for_data_info: false,
            check_load_data_info: false,
        }
        
        default:
            return state
    }
}